import OUTLANDER_2025 from '../data/model/outlander-2025/en'
import OUTLANDER_2026 from '../data/model/outlander-2026/en'
import ECLIPSE_CROSS_2026 from '../data/model/eclipse-cross-2026/en'
import RVR_2026 from '../data/model/rvr-2026/en'

const EN = {
  ...OUTLANDER_2025,
  ...OUTLANDER_2026,
  ...ECLIPSE_CROSS_2026,
  ...RVR_2026,
  'virtual.tour.card.interior.title': 'Explore the Interior',
  'virtual.tour.card.interior.cta': 'Take the virtual tour',
  'virtual.tour.card.exterior.title': 'Explore the Exterior',
  'virtual.tour.card.exterior.cta': 'Take the virtual tour',

  'tourController.interior': 'Interior',
  'tourController.exterior': 'Exterior',

  'blueprint.soundSystem.question': 'Which sound system option would you like to explore?',
  'blueprint.soundSystem.yamahaUltimate': 'Yamaha Ultimate',
  'blueprint.soundSystem.yamahaPremium': 'Yamaha Premium',
  'blueprint.soundSystem.includedIn': 'Included in:',
  'blueprint.soundSystem.includedInUltimate': 'GT, GT Premium',
  'blueprint.soundSystem.includedInPremium': 'ES, SE, LE, and SEL',
  'blueprint.soundSystem.hotspot-1.label': 'Mid-Range Speakers',
  'blueprint.soundSystem.hotspot-1.message': 'Mid-range speakers',
  'blueprint.soundSystem.hotspot-2.label': 'Tweeters',
  'blueprint.soundSystem.hotspot-2.message': 'Tweeters',
  'blueprint.soundSystem.hotspot-3.label': 'Woofers',
  'blueprint.soundSystem.hotspot-3.message': 'Woofers',
  'blueprint.soundSystem.hotspot-4.label': 'Subwoofer',
  'blueprint.soundSystem.hotspot-4.message': 'Subwoofer',

  'blueprint.safety.question': 'Which SRS would you like to explore?',
  'blueprint.safety.includedIn': 'Included in:',
  'blueprint.safety.allTrims': 'All trims',

  'launcher.expand': 'Expand',
  'chatWrapper.collapse': 'Collapse',
  'chatWrapper.AICanMakeMistakes': 'The AI Intelligent Companion can make mistakes.',
  'chatWrapper.checkImportantInfo': 'Check important info. ',
  'chatWrapper.privacyPolicy': 'Privacy Policy',
  'chatWrapper.privacyPolicyLink': 'https://www.mitsubishi-motors.ca/en/legal/privacy-policy',

  'hotspot.soundSystem': 'Sound system',
  'hotspot.allWheelControl': 'All wheel control',
  'hotspot.safetyFeatures': 'Safety features',
  'hotspot.mitsubishiConnect': 'Mitsubishi Connect',
  'hotspot.warranty': 'Warranty',
  'hotspot.SAWC': 'S-AWC',
  'hotspot.cargoSpace': 'Cargo Space',
}

export default EN
